var React = require('react');

function Briefcase (props) {
    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"Stresskoffert"),React.createElement("path",{"d":"M1.5 16.5v-6h5.25c0 .596.234 1.16.664 1.59.429.426.992.66 1.586.66 1.24 0 2.25-1.01 2.25-2.25h5.25l-.002 6H1.5zM8.25 9A.75.75 0 0 1 9 8.25a.758.758 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75.758.758 0 0 1-.75-.75V9zm8.25-3.75V9h-5.25c0-.596-.234-1.16-.664-1.59A2.24 2.24 0 0 0 9 6.75C7.76 6.75 6.75 7.76 6.75 9H1.5V5.25h15zM6.75 3a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v.75h-4.5V3zm9.75.75h-3.75V3c0-1.24-1.01-2.25-2.25-2.25h-3C6.26.75 5.25 1.76 5.25 3v.75H1.5c-.827 0-1.5.673-1.5 1.5V16.5c0 .827.673 1.5 1.5 1.5h15c.827 0 1.5-.673 1.5-1.5V5.25c0-.827-.673-1.5-1.5-1.5z","key":1})]);
}

Briefcase.displayName = "Briefcase";

Briefcase.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = Briefcase;

Briefcase.default = Briefcase;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/briefcase.svg
// module id = 1259
// module chunks = 0